import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { Navigate, Outlet } from 'react-router-dom';
import FeatureGates from '@atlaskit/feature-gate-js-client';
import { media } from '@atlaskit/primitives/responsive';

import { ALM_INTEGRATION_FF } from 'src/constants';
import { isDevelopment } from 'src/services/http/user';

import { Banner } from './Banner';

export const Layout = () => {
  if (!isDevelopment() && !FeatureGates.checkGate(ALM_INTEGRATION_FF)) {
    return <Navigate to="/" replace />;
  }

  return (
    <main css={mainContainerStyles} data-testid="team-training-page">
      <Banner />
      <div css={mainContentStyles}>
        <div css={contentWrapperStyles}>
          <Outlet />
        </div>
      </div>
    </main>
  );
};

const mainContainerStyles = css({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'clip',
});

const mainContentStyles = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  padding: `${token('space.400')} ${token('space.300')}`,

  [media.below.sm]: {
    padding: `${token('space.300')} ${token('space.200')}`,
  },
});

const contentWrapperStyles = css({
  maxWidth: '1200px',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: token('space.400'),
});
